import { Card, CircularProgress, Grid, Hidden, Typography } from '@material-ui/core';
import { useEffect, useState } from 'react';
import { getBranchAndFranchise } from '../../Service/branch-screen-service';
import { Alert } from '@material-ui/lab';

export default function PartReqCommon({ header, state, array, classes, handleChangeByPartsReq, List, handleClick }) {
    const isPartReq = (header || '').toLowerCase().includes('part');
    const total = (List || []).reduce((acc, item) => acc + (Number(item?.value) || 0), 0);

    return (
        // <Grid item container xs={12} sm={12} md={12} lg={12} xl={6} style={{ padding: 5, boxSize: 'none' }}>
        <>
            {state.showHeaderLoader ? (
                <div className="wip-dash-Card">
                    <div className="pieChartSize" style={{ display: 'flex' }}>
                        <CircularProgress className="wip-loader" />
                    </div>
                </div>
            ) : (
                <Card className="wip-dash-Card">
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 6 }}>
                        <Typography variant="h6" className="dashHeading">
                            {header}
                            <span className="dash-heading-total">( Total : {total} )</span>
                        </Typography>
                    </div>

                    <div className={`dash-stat-tiles-row ${isPartReq ? 'part-req-grid' : 'returns-grid'}`}>
                        {List.map((item, index) => (
                            <div
                                className="dash-stat-tile-col"
                                key={item.label || index}
                                onClick={() =>
                                    handleClick(
                                        {
                                            workflow: array.byTimeObj?.workflow,
                                            bn: array.byTimeObj?.bn,
                                            id: item.code || '',
                                            statusID: item.statusid || '',
                                            label: item.label
                                        },
                                        true
                                    )
                                }
                            >
                                <div
                                    // style={{
                                    //     borderLeft: item.BarColor || '6px solid #183B68'
                                    // }}
                                    className="dash-stat-tile"
                                    title={item.label}
                                >
                                    <span className="lableFont">{item.label}</span>
                                    <div className="valueFont">{item.value || 0}</div>
                                </div>
                            </div>
                        ))}
                    </div>
                </Card>
            )}
        </>
        // </Grid>
    );
}
